/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { loginPostRequestSchema } from './loginPostRequestSchema.ts';
import { loginPostResponseSchema } from './loginPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postLogin200Schema = z.lazy(() => loginPostResponseSchema);

/**
 * @description 505 response
 */
export const postLogin505Schema = z.any();

export const postLoginMutationRequestSchema = z.lazy(() => loginPostRequestSchema);

export const postLoginMutationResponseSchema = z.lazy(() => postLogin200Schema);
